module.exports = require("./sat.d.ts");